/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiProductsqueryInternalSalesarticlesStockIdGet$Plain$Params {
  id: string;
}

export function apiProductsqueryInternalSalesarticlesStockIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiProductsqueryInternalSalesarticlesStockIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryInternalSalesarticlesStockIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

apiProductsqueryInternalSalesarticlesStockIdGet$Plain.PATH = '/api/productsquery/internal/salesarticles/stock/{id}';
